import React from 'react'

import {
  B3,
  B4,
  Icon,
  SH3,
  Stack,
  XStack,
  colors as zetColors,
} from '@zet/design-system'
import { useUserContext } from '@zet/feature-user'
import { i18n } from '@zet/localization'
import { LeadStatus } from '@zet/utils/Constants'
import moment from 'moment'

import ReopenLead from './reopenLead'

type LeadRejectedProps = {
  item?: object
  brandName?: string
  inactive?: boolean
}

const LeadRejected = ({ item, brandName, inactive }: LeadRejectedProps) => {
  const status = item?.status
  const customerId = item?.customerId
  const partnerId = item?.partnerId
  const { data: user } = useUserContext()

  if (status === LeadStatus.REJECTED) {
    return (
      <Stack className="border-grays-30 bg-neutral-white100 mt-2 rounded-sm border-l-4">
        <XStack className="pt-4/2 px-3">
          <Stack className="bg-error-20 absolute left-[30] h-4 w-1" />
          <Stack className="bg-error-20 absolute left-3 top-3 items-center rounded-lg">
            <Icon
              type={'CautionOutlined'}
              size={20}
              color={zetColors.error[100]}
              className="m-1.5"
            />
          </Stack>
          <Stack className="left-6 justify-center">
            <SH3 className="  text-grays-80">
              {i18n.t('leads.leadRejected')}
            </SH3>
            <B4 className=" text-grays-50">
              {i18n.t('leads.rejectOn', {
                date: moment.utc(item?.lastUpdatedDate).format('DD-MMM-YYYY'),
              })}
            </B4>
          </Stack>
        </XStack>

        <Stack className=" bg-error-20 mx-3 my-2 rounded">
          <B3 className="px-4/2 text-grays-60  py-2">
            {item?.rejectionReason
              ? item?.rejectionReason
              : i18n.t('leads.rejectionDescription', { brandName: brandName })}
          </B3>
        </Stack>
        <ReopenLead
          reopen={item?.isReopenAllowed}
          reopenDays={item?.reopenDays}
          reopenDate={item?.reopenDate}
          shareNewLink={item?.isShareNewLink}
          inactive={inactive}
          leadId={item?.id}
          leadStatus={status}
          userId={user?.id}
          customerId={customerId}
          customerName={item?.name}
          customerPhoneNumber={item?.phoneNumber}
          partnerId={partnerId}
          brandName={brandName}
        />
      </Stack>
    )
  }
}

export default LeadRejected
